export default{
    getAddId:(context,data)=>{
        context.commit('ADDID', data)
    }
}


// WEBPACK FOOTER //
// ./src/vuex/actions/actions.js